// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__t9wAH","range":"MonthRangeSwitch_range__xpM8y","disabled":"MonthRangeSwitch_disabled__EcsdD"};